import { FormControlLabel, Grid, Switch } from "@mui/material";
import { FastField } from "formik";
import {
  MyMultiSelect,
  MySelect,
  MySelectTime,
  MyTextField,
  MyTextFieldArea
} from "../Lib/componentLibrarys";
import Api from "../../api2";
import { useState } from "react";
import { isEmpty } from "lodash";

export const FormNhap = ({
  view,
  values,
  errors,
  setFieldValue,
  sanPhamList,
  coSoCheBienList
}) => {
  const [thongTinCheBienList, setThongTinCheBienList] = useState(null)
  const getApiThongTinLichSuCheBien = (listIdCoSoCheBien) => {
    new Api().GetListThongTinLichSuCheBienOfCoSoCheBien(listIdCoSoCheBien).then(data => {
      if (data.code === 200) {
        setThongTinCheBienList(data?.data);
        const listDataThongTinCB = data?.data
        if (isEmpty(listDataThongTinCB)) {
          setFieldValue('lichSuCheBiens', null)
        } else if (!isEmpty(values?.lichSuCheBiens)) {
          const validIds = new Set(listDataThongTinCB?.map(item => item?.id));
          const dataThongTinCbHandle = values?.lichSuCheBiens?.filter(item => validIds.has(item?.id));
          setFieldValue('lichSuCheBiens', dataThongTinCbHandle)
        }
      }
    });
  }

  return (
    <div>
      <Grid container spacing={1} style={{ marginTop: "0px" }}>
        <Grid item xs={6}>
          <FastField name="tenLoHang">
            {({ field }) => (
              <MyTextField
                required
                disabled={view}
                label="Tên lô hàng:"
                placeholder="Nhập..."
                errors={errors?.tenLoHang}
                helperText={errors?.tenLoHang}
                {...field}
              />
            )}
          </FastField>
        </Grid>
        <Grid item xs={6}>
          <MySelect
            disabled={view}
            label="Sản phẩm:"
            placeholder="Chọn..."
            value={values?.sanPham}
            options={sanPhamList || []}
            name="tenSanPham"
            onChange={(event, value) => {
              setFieldValue(`sanPham`, value);
            }}
          />
        </Grid>
        <Grid item xs={6}>
          <MyMultiSelect
            disabled={view}
            label="Cơ sở chế biến:"
            placeholder="Chọn..."
            isOptionEqualToValue={(option, value) => (
              option?.id === value?.id
            )}
            onChange={(option, value) => {
              setFieldValue(`coSoCheBiens`, value);
              const handleValueId = value?.map(x => x?.id)
              if(!isEmpty(handleValueId)) {
                getApiThongTinLichSuCheBien(handleValueId)
              } else {
                setThongTinCheBienList([])
                setFieldValue('lichSuCheBiens', null)
              }
            }}
            value={values?.coSoCheBiens || []}
            options={coSoCheBienList || []}
            name="tenCoSoCheBien"
          />
        </Grid>
        <Grid item xs={6}>
          <MyMultiSelect
            disabled={view}
            label="Thông tin lịch sử chế biến:"
            placeholder="Chọn..."
            onChange={(option, value) => {
              setFieldValue(`lichSuCheBiens`, value);
            }}
            isOptionEqualToValue={(option, value) => (
              option?.id === value?.id
            )}
            value={values?.lichSuCheBiens || []}
            options={thongTinCheBienList || []}
            name="tenThongTinCheBien"
          />
        </Grid>
        <Grid item xs={6}>
          <MySelectTime
            disabled={view}
            label="Ngày xuất bán:"
            placeholder="Chọn..."
            value={values?.ngayXuatBan}
            onChange={value => {
              setFieldValue(`ngayXuatBan`, value);
            }}
            width="100%"
          />
        </Grid>
        <Grid item xs={6}>
          <FastField name="hanSuDung">
            {({ field }) => (
              <MyTextField
                label="Hạn sử dụng:"
                placeholder="Nhập..."
                {...field}
                disabled={view}
              />
            )}
          </FastField>
        </Grid>
        <Grid item xs={6}>
          <FastField name="sanLuong">
            {({ field }) => (
              <MyTextField
                disabled={view}
                label="Sản lượng:"
                placeholder="Nhập..."
                {...field}
              />
            )}
          </FastField>
        </Grid>
        <Grid item xs={6}>
          <FormControlLabel
            style={{ marginLeft: 0.5, alignItems: "center", marginTop: 20 }}
            control={
              <Switch
                disabled={view}
                checked={values?.trangThai}
                onChange={(event, value) => {
                  setFieldValue("trangThai", value);
                }}
              />
            }
            label="Trạng thái"
          />
        </Grid>
        <Grid item xs={12}>
          <FastField name="ghiChu">
            {({ field }) => (
              <MyTextFieldArea
                disabled={view}
                label="Ghi chú:"
                placeholder="Nhập..."
                maxRows={3}
                {...field}
              />
            )}
          </FastField>
        </Grid>
      </Grid>
    </div>
  );
};
